'use client'
import { CaptionProps, useNavigation } from 'react-day-picker'
import { format } from 'date-fns'
import { dayPickerFormats, testIds } from '@/root/shared-consts'
import Icon from '@/root/ui/shared/Icon'
import { useCustomRouter } from '@/root/shared-hooks'
import { getDateFnsLocale } from '@/root/components/shared/DayPicker/CustomNavbar/CustomNavBar'

// Penpot "UI components / Calendar" month selection: arrows at the edges, month centred, not uppercased
export const CustomNavbar = (props: CaptionProps) => {
  const { goToMonth, nextMonth, previousMonth } = useNavigation()
  const { locale } = useCustomRouter()
  const formatMonth = (month: Date) => format(month, dayPickerFormats.general, { locale: getDateFnsLocale(locale) })

  return (
    <div className="flex w-full items-center justify-between px-3.5 pb-2.5">
      <button
        type="button"
        data-testid={testIds.search.calendarBack}
        aria-label={previousMonth && formatMonth(previousMonth)}
        disabled={!previousMonth}
        onClick={() => previousMonth && goToMonth(previousMonth)}
      >
        <Icon type="CalendarChevronLeft" alt="" width={8} height={14} color="base-medium-light" />
      </button>
      <h2 className="text-neutral-darker flex-1 text-center text-base font-semibold">
        {formatMonth(props.displayMonth)}
      </h2>
      <button
        type="button"
        data-testid={testIds.search.calendarForward}
        aria-label={nextMonth && formatMonth(nextMonth)}
        disabled={!nextMonth}
        onClick={() => nextMonth && goToMonth(nextMonth)}
      >
        <Icon type="CalendarChevronRight" alt="" width={8} height={14} color="base-medium-light" />
      </button>
    </div>
  )
}
